module.exports = "<div class=\"modal-detail-container hide-modal-detail\">\n    <div class=\"modal-detail\">\n        <ng-content></ng-content>\n    </div>\n    <div class=\"modal-detail-mask\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/modal-detail-doc/modal-detail-doc.component.html
// module id = ./src/app/shared/components/modal-detail-doc/modal-detail-doc.component.html
// module chunks = main